<div class="hops-game" [class.is-immersive]="isFullscreen" *ngIf="round">

  <!-- Prompt: N × a/b -->
  <div class="prompt-bar">
    <span class="prompt-text">{{ currLang === 'ar' ? 'اقفز' : 'Hop' }}</span>
    <span class="expr">
      <span class="whole">{{ round.whole }}</span>
      <span class="times">&#215;</span>
      <span class="fraction">
        <span class="num">{{ round.num }}</span>
        <span class="bar"></span>
        <span class="den">{{ round.den }}</span>
      </span>
    </span>
  </div>

  <!-- Whose turn -->
  <div class="turn-chip" *ngIf="student">
    <app-student-avatar [student]="student" [size]="46" [active]="true"></app-student-avatar>
    <div class="turn-text">
      <span class="turn-name">{{ studentName }}</span>
      <span class="turn-label">{{ currLang === 'ar' ? 'دورك!' : "it's your turn" }}</span>
    </div>
  </div>

  <!-- Round progress -->
  <div class="round-dots">
    <span class="dot" *ngFor="let d of roundDots; let i = index"
          [class.done]="solvedFlags[i]" [class.current]="i === currentRound"></span>
  </div>

  <!-- Interactive stage -->
  <div class="stage-wrap">
    <app-fraction-hops-stage
      [round]="round"
      [roundKey]="currentRound"
      [interactive]="!resolving"
      [currLang]="currLang"
      (solved)="onSolved()"
      (missed)="onMissed()">
    </app-fraction-hops-stage>
  </div>

  <!-- Controls -->
  <div class="controls">
    <button class="ctrl-btn undo-btn" [disabled]="resolving || !stage?.canUndo" (click)="onUndo()">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M9 14L4 9l5-5M4 9h11a5 5 0 010 10h-1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      {{ currLang === 'ar' ? 'تراجع' : 'Undo' }}
    </button>

    <button class="ctrl-btn hop-btn" [disabled]="resolving || !stage?.canHop" (click)="onHop()">
      <span aria-hidden="true">🐸</span>
      {{ currLang === 'ar' ? 'اقفز' : 'HOP' }}
    </button>

    <button class="ctrl-btn land-btn" [disabled]="resolving || !stage?.canLand" (click)="onLand()">
      {{ currLang === 'ar' ? 'هبوط' : 'LAND' }}
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <button class="ctrl-btn skip-btn" [disabled]="resolving" (click)="skip()">
      {{ currLang === 'ar' ? 'تخطّي' : 'Skip' }}
    </button>
  </div>

  <!-- Success burst -->
  <div class="success-overlay" *ngIf="showSuccess">
    <div class="success-card">
      <div class="success-icon" aria-hidden="true">🐸</div>
      <div class="success-title">{{ currLang === 'ar' ? 'قفزات صحيحة!' : 'Perfect hops!' }}</div>
      <div class="success-xp" *ngIf="lastXp > 0">+{{ lastXp }} XP</div>
    </div>
  </div>

  <app-fullscreen-toggle [isFullscreen]="isFullscreen" [currLang]="currLang" (toggle)="toggleFullscreen()"></app-fullscreen-toggle>
</div>
